export const INVOICE_CONSTANTS = {
  BANK_NAME: 'Bank Name',
  CLIENT_NAME: 'Client Name',
  BRANCH_NAME: 'Branch Name',
  BANK_REPRESENTATIVE: 'Bank Representative',
  BANK_NAME_AR: 'اسم البنك',
  CLIENT_NAME_AR: 'اسم العميل',
  BRANCH_NAME_AR: 'اسم الفرع',
  BANK_REPRESENTATIVE_AR: 'ممثل البنك',
  INVOICE: 'Invoice',
  INVOICE_AR: 'فاتورة',
  INVOICE_DATE: 'Invoice Date',
  QUOTATION_NUMBER: 'Quotation Number',
  REFERENCE: 'Reference',
  INVOICE_DATE_AR: 'تاريخ الفاتورة',
  QUOTATION_NUMBER_AR: 'رقم عرض السعر',
  REFERENCE_AR: 'رقم الإشارة',
  TOTAL_PRICE: 'TOTAL PRICE',
  AMOUNT: 'AMOUNT',
  UNIT_PRICE: 'UNIT PRICE',
  QUANTITY: 'QUANTITY',
  DESCRIPTION: 'DESCRIPTION',
  TOTAL_PRICE_AR: 'السعر الاجمالي',
  AMOUNT_AR: 'مبلغ',
  UNIT_PRICE_AR: 'سعر الوحدة',
  QUANTITY_AR: 'الكمية',
  DESCRIPTION_AR: 'الوصف',
  SUB_TOTAL: 'Subtotal',
  SUB_TOTAL_AR: 'الإجمالي الفرعي',
  TOTAL: 'Total',
  TOTAL_AR: 'المجموع',
  COMPANY_SIGNATURE: 'Company Signature',
  COMPANY_SIGNATURE_AR: 'توقيع الشركة',
  PAYMENT_REFERENCE: 'Payment Reference',
  PAYMENT_REFERENCE_AR: 'رقم إشارة الدفعة',
  PAGE: 'Page',
  AMOUNT_IN_WORDS: 'Amount in Words',
  PHONE_NUMBER: '+965 22960510',
};

export const STYLE_RULES = [
  { selector: '.info-table th, .info-table td', styles: { 'text-align': 'left' } },
  { selector: '.english-labels', styles: { 'text-align': 'right' } },
  { selector: '.value-section', styles: { 'text-align': 'left' } },
  { selector: '.arabic-labels, .arabic-right', styles: { 'text-align': 'right', direction: 'rtl' } },
  { selector: '.invoice-table thead .header-row td, .invoice-table td', styles: { 'text-align': 'right' } },
  { selector: '.right-cell', styles: { 'text-align': 'left' } },
  { selector: '.left-cell', styles: { 'text-align': 'right' } },
  { selector: '.label-cell, .value-cell', styles: { 'text-align': 'left' } },
  { selector: '.arabic-label-cell', styles: { 'text-align': 'left', direction: 'rtl' } },
  { selector: '.arabic-text', styles: { direction: 'ltr' } },
];
